import { microCreditsToCredits } from '@blogforge/shared';

// ─────────────────────────────────────────────────────────────────
// Billing display helpers — money (minor units → currency), credits
// (micro → whole), and date formatting shared by the billing pages.
// ─────────────────────────────────────────────────────────────────

export function formatMoney(amountMinorUnits: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(amountMinorUnits / 100);
  } catch {
    return `${(amountMinorUnits / 100).toFixed(2)} ${currency}`;
  }
}

export function formatCredits(microCredits: number, maxFractionDigits = 2): string {
  return microCreditsToCredits(microCredits).toLocaleString(undefined, {
    maximumFractionDigits: maxFractionDigits,
  });
}

export function formatSignedCredits(microCredits: number): string {
  const sign = microCredits > 0 ? '+' : microCredits < 0 ? '−' : '';
  return `${sign}${formatCredits(Math.abs(microCredits))}`;
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}
